module.exports = __webpack_public_path__ + "static/media/burrito.035d4a38.svg";